export default __webpack_public_path__ + "static/media/112.76611be8.jpg";